import {useThrottleFn} from '@vueuse/core'
import {useUserStore} from '@/stores'
import {useRepository} from '@/composables'
import {mediator} from '@communication'

const clientWhitelist = ['board:tap:casted']

export const useBoard = () => {
  const user = useUserStore()
  const {sendWsEvent} = useRepository()

  const send = useThrottleFn((message: {type: string; data?: any}, mode: 'debounced' | 'immediate') => {
    const {type} = message
    if (user.isAssistant || (user.isClient && clientWhitelist.includes(type))) {
      mediator.broadcast(message)
      sendWsEvent(message)
    }
  }, 33) // backend records ~30fps, so ~33ms between continuous messages is enough
  return {send}
}
